import { render, staticRenderFns } from "./NewCreateTask.vue?vue&type=template&id=79c59f78&"
import script from "./NewCreateTask.vue?vue&type=script&lang=js&"
export * from "./NewCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./NewCreateTask.vue?vue&type=style&index=0&id=79c59f78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports